import { useGetAllRewardsQuery } from "@apis/rewards/useRewards"
import { tableColumnsSummary } from "./utils/tableColumnsSchema"
import { DataTable } from "@components/DataTable/DataTable"
import { PageTitle } from "@components/PageTitle"
import { useSortingState } from "@hooks/useSortingState"
import { useNavigate } from "react-router"

export const AllRewards = () => {
  const navigate = useNavigate()
  const { data, isPending, isError, error } = useGetAllRewardsQuery()
  const sorting = useSortingState([
    { id: "rewards_pending_approved_amount_count", desc: true },
  ])

  if (isError) {
    return (
      <div className="tw:py-4 tw:text-red-500">
        There was an error loading the summary. Error: {error.message}
      </div>
    )
  }

  return (
    <div className="tw:container tw:flex tw:flex-col tw:gap-8">
      <PageTitle title="Rewards" />

      <DataTable
        columns={tableColumnsSummary}
        data={data ?? []}
        pending={isPending}
        onRowClick={(row) =>
          navigate(`/ops/rewards/${row.fulfillment_vendor_code}`)
        }
        {...sorting}
      />
    </div>
  )
}
